import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import KitchenView from '../views/KitchenView.vue';
import KitchenOrderView from '../views/kitchen/KitchenOrderView.vue';
import TableManageView from '@/views/staff/TableManageView.vue';
import ServingHistoryView from '../views/kitchen/ServingHistoryView.vue';
import KitchenDispatchView from '../views/kitchen/KitchenDispatchView.vue';
import KitchenServingView from '../views/kitchen/KitchenServingView.vue';
import ChefScreenView from '@/views/kitchen/ChefScreenView.vue';
import OrderNewView from '../views/order/OrderNewView.vue';
import OrderDetailView from '../views/order/OrderDetailView.vue';
import OrderHistoryView from '../views/order/OrderHistoryView.vue';
import OrderCheckOutView from '../views/order/OrderCheckOutView.vue';
import DishAssignmentView from '../views/kitchen/DishAssignmentView.vue';
import PickUpFoodView from '../views/order/PickUpFoodView.vue';
import FoodCategoryManageView from '../views/manage/FoodCategoryManageView.vue';
import FoodManageView from '../views/manage/FoodManageView.vue';
import FoodStockManageView from '../views/manage/FoodStockManageView.vue';
import FoodLabelManageView from '../views/manage/FoodLabelManageView.vue';
import MenuImageGenerateView from '../views/manage/MenuImageGenerateView.vue';
import OrderReportView from '../views/manage/OrderReportView.vue';
import PickCodeVerificationView from '../views/order/PickCodeVerificationView.vue';
import BuffetVerificationView from '../views/order/BuffetVerificationView.vue';
import EmployeeCouponManageView from '../views/staff/EmployeeCouponManageView.vue';
import LoginView from '../views/auth/LoginView.vue';
import ForbiddenView from '../views/auth/ForbiddenView.vue';
import { useAuthStore } from '@/store/auth';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { title: '登录', public: true, redirectIfAuthed: true },
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    component: ForbiddenView,
    meta: { title: '无访问权限' },
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '首页' },
  },
  {
    path: '/kitchenOrder',
    name: 'kitchenOrder',
    component: KitchenOrderView,
    meta: {
      title: '订单出餐',
      showInMenu: true,
      menuOrder: 20,
      menuIcon: '🍸',
    },
  },
  {
    path: '/orderHistory',
    name: 'orderHistory',
    component: OrderHistoryView,
    meta: {
      title: '订单查询',
      showInMenu: true,
      menuOrder: 40,
      menuIcon: '📖',
    },
  },
  {
    path: '/kitchen1',
    name: 'kitchen1',
    component: KitchenView,
    meta: { title: '厨房看板', permissionMenu: 'kitchenOrder' },
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: { title: '关于', permissionMenu: 'kitchenOrder' },
  },
  {
    path: '/tableManage',
    name: 'tableManage',
    component: TableManageView,
    meta: {
      title: '餐厅管理',
      showInMenu: true,
      menuOrder: 10,
      menuIcon: '👔',
    },
  },
  {
    path: '/servingHistory',
    name: 'servingHistory',
    component: ServingHistoryView,
    meta: {
      title: '出菜历史',
      showInMenu: true,
      menuOrder: 70,
      menuIcon: '📜',
    },
  },
  {
    path: '/kitchenDispatch',
    name: 'kitchenDispatch',
    component: KitchenDispatchView,
    meta: {
      title: '预定菜品',
      showInMenu: true,
      menuOrder: 80,
      menuIcon: '🧭',
    },
  },
  {
    path: '/deliveryOrderFood',
    name: 'deliveryOrderFood',
    component: KitchenDispatchView,
    props: { reportType: 'delivery' },
    meta: {
      title: '外卖菜品',
      showInMenu: true,
      menuOrder: 85,
      menuIcon: '🛵',
    },
  },
  {
    path: '/kitchenServing',
    name: 'kitchenServing',
    component: KitchenServingView,
    meta: {
      title: '厨房出菜',
      showInMenu: true,
      menuOrder: 50,
      menuIcon: '🔥',
    },
  },
  {
    path: '/chefScreen',
    name: 'chefScreen',
    component: ChefScreenView,
    meta: {
      title: '厨师大屏',
      showInMenu: true,
      menuOrder: 55,
      menuIcon: '👨‍🍳',
    },
  },
  {
    path: '/orderNew',
    name: 'orderNew',
    component: OrderNewView,
    meta: {
      title: '新建订单',
      permissionMenu: 'tableManage',
    },
  },
  {
    path: '/orderDetails',
    name: 'orderDetails',
    component: OrderDetailView,
    meta: { title: '订单详情', permissionMenu: 'orderHistory' },
  },
  {
    path: '/orderCheckOut',
    name: 'orderCheckOut',
    component: OrderCheckOutView,
    meta: { title: '订单结账', permissionMenu: 'tableManage' },
  },
  {
    path: '/dishAssignment',
    name: 'dishAssignment',
    component: DishAssignmentView,
    meta: {
      title: '菜品分配',
      showInMenu: true,
      menuOrder: 60,
      menuIcon: '🥗',
    },
  },
  {
    path: '/pickupFood',
    name: 'pickupFood',
    component: PickUpFoodView,
    meta: { title: '取餐提醒', permissionMenu: 'tableManage' },
  },
  {
    path: '/pickCodeVerify',
    name: 'pickCodeVerify',
    component: PickCodeVerificationView,
    meta: {
      title: '取餐码核销',
      showInMenu: true,
      menuOrder: 100,
      menuIcon: '📷',
    },
  },
  {
    path: '/buffetVerify',
    name: 'buffetVerify',
    component: BuffetVerificationView,
    meta: {
      title: '餐券核销',
      showInMenu: true,
      menuOrder: 110,
      menuIcon: '✅',
    },
  },
  {
    path: '/employeeCouponManage',
    name: 'employeeCouponManage',
    component: EmployeeCouponManageView,
    meta: {
      title: '员工餐券管理',
      showInMenu: true,
      menuOrder: 115,
      menuIcon: '🎫',
    },
  },
  {
    path: '/foodCategoryManage',
    name: 'foodCategoryManage',
    component: FoodCategoryManageView,
    meta: { title: '菜品分类管理', permissionMenu: 'foodManage' },
  },
  {
    path: '/foodManage',
    name: 'foodManage',
    component: FoodManageView,
    meta: {
      title: '菜品管理',
      showInMenu: true,
      menuOrder: 120,
      menuIcon: '🍜',
    },
  },
  {
    path: '/foodStockManage',
    name: 'foodStockManage',
    component: FoodStockManageView,
    meta: {
      title: '菜品库存管理',
      showInMenu: true,
      menuOrder: 125,
      menuIcon: '📦',
    },
  },
  {
    path: '/foodLabelManage',
    name: 'foodLabelManage',
    component: FoodLabelManageView,
    meta: { title: '菜品标签管理', permissionMenu: 'foodManage' },
  },
  {
    path: '/menuImageGenerate',
    name: 'menuImageGenerate',
    component: MenuImageGenerateView,
    meta: { title: '菜单图生成', permissionMenu: 'foodManage' },
  },
  {
    path: '/orderReport',
    name: 'orderReport',
    component: OrderReportView,
    meta: {
      title: '订单报表',
      showInMenu: true,
      menuOrder: 130,
      menuIcon: '📊',
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to) => {
  const authStore = useAuthStore();
  const isPublicRoute = Boolean(to.meta.public);
  const redirectIfAuthed = Boolean(to.meta.redirectIfAuthed);
  const isForbiddenRoute = to.name === 'forbidden';

  if (isPublicRoute) {
    if (redirectIfAuthed && (await authStore.ensureValidSession())) {
      return { path: authStore.hasSystemAccess ? '/' : '/forbidden' };
    }
    return true;
  }

  if (!(await authStore.ensureValidSession())) {
    return {
      path: '/login',
      query: { redirect: to.fullPath },
    };
  }

  if (isForbiddenRoute) {
    return true;
  }

  if (!authStore.hasSystemAccess) {
    return { path: '/forbidden' };
  }

  const permissionMenu =
    typeof to.meta.permissionMenu === 'string'
      ? to.meta.permissionMenu
      : to.meta.showInMenu
      ? String(to.name || '')
      : '';
  if (permissionMenu && !authStore.hasMenuPermission(permissionMenu)) {
    return { path: '/' };
  }

  return true;
});

export default router;
